import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import bindAll from 'lodash/bindAll'
import { DefaultPlayer as Video } from 'react-html5video'
import CopyToClipboard from 'react-copy-to-clipboard'
import imgDefaultLogo from '../../../images/public/company_empty.png'
import Notifications from 'react-notification-system-redux'
import 'react-html5video/dist/styles.css'
import { publicCandidateGetVideo } from '../../../actions/public/candidates'

require('es6-promise').polyfill()

class CandidateVideo extends Component {
	constructor(props) {
		super(props)

		bindAll(this, [
			'handleCopyClick'
		])
	}

	componentDidMount(){
		const {	publicCandidateGetVideo } = this.props

		publicCandidateGetVideo(this.props.hashVideoId)
	}

	handleCopyClick(){
		const { showNotifications } = this.props

		showNotifications(
			'Success',
			'Video link copied.',
			'bl'
		)
	}

	render() {
		const {
			publicCandidate,
			notifications
		} = this.props

		const company = publicCandidate.company || {}
		const candidate = publicCandidate.candidate || {}
		const job = publicCandidate.job || {}
		const question = publicCandidate.question || {}

		const companyLogo =
			<img
				className="company-logo"
				src={ !isEmpty(company.logoUrl) ? company.logoUrl : imgDefaultLogo }
				alt={company.title} />

		return(
			<div>
				<div className="row">
					<div className="container-fluid bg-white">
						<div className="job-listing">
							<div className="job-detail">
								<div className="container wrapper-joblist">
									<div className="row">
										<div className="col-sm-12">
											<div className="company-detail">
												<div className="logo"> {companyLogo} </div>
											</div>
										</div>
									</div>
								</div>
								<div className="border-line"></div>
								<div className="container wrapper-joblist">
									<div className="row">
										<div className="col-sm-6">
											{
												!isEmpty(publicCandidate.video_url) ?
												<Video poster={publicCandidate.thumbnail_url} autoPlay>
													<source src={publicCandidate.video_url} />
												</Video>
												:
												<div className="empty-video">
													<div className="placehold flex-container flex-center align-items-center">
														<div>
															<h4>No video</h4>
															<p>Candidate has not answered this question yet</p>
														</div>
													</div>
												</div>
											}
										</div>
										<div className="col-sm-6">
											<div className="box-list">
												<div className="fullname">
													<div className="form-group">
														<h1>{candidate.fullname}</h1>
													</div>
												</div>
												<div className="description">
													<div className="form-group">
														<label>Job</label>
														<h4>{job.title}</h4>
													</div>
													<div className="form-group">
														<label>Company</label>
														<h4>{company.title}</h4>
													</div>
												</div>
												<div className="question">
													<div className="form-group">
														<label>Question</label>
														<h4>{question.title}</h4>
													</div>
												</div>
												<CopyToClipboard
													text={window.location.href}
													onCopy={this.handleCopyClick}>
													<a className="btn btn-xsmall btn-border">Copy Link</a>
												</CopyToClipboard>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<Notifications notifications={notifications} />
				</div>
				<footer className="listing-footer">
						<div className="copy">
							<a href="http://astrnt.co">Powered by ASTRNT</a>
						</div>
				</footer>
			</div>
		)
	}
}

CandidateVideo.propTypes = {
  publicCandidateGetVideo: PropTypes.func.isRequired,
	hashVideoId: PropTypes.string.isRequired,
	notifications: PropTypes.array
}

const mapStateToProps = (state, ownProps) => {
  return {
		publicCandidate: state.publicCandidate.toJS(),
		notifications: state.notifications,
		hashVideoId: ownProps.match.params.hashVideoId
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
		publicCandidateGetVideo: (hashVideoId) => dispatch(publicCandidateGetVideo(hashVideoId)),
		showNotifications: (title, message, position) => {
			return dispatch(Notifications.success({
			  title,
			  message,
				position
			}))
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(CandidateVideo)
